
import { WebObjectModel } from '../../Models/web-object-model';
import { WebObjectTypeService } from 'src/app/Services/web-object-type.service';
import { WebObjectTypeModel } from 'src/app/Models/web-object-type-model';

export class WebobjectMock {

  private static models: WebObjectModel[];
  private static  idCounter = 0;
  private static wom1:WebObjectTypeModel;
  private static webObjectTypeService: string;

  public static initMocks(){
    WebobjectMock.models = [];
    // this.wom1=WebObjectTypeService.findById("gffnweftewf7775");
    WebobjectMock.models.push({_id:"iu2gfin32f23", type: "WEB", deleted: 0, collectionName: "", request: {}, dbName: "db1", webPageId: "", name: "UserNameInput",/*  wId :++this.idCounter, */ webobjectType: "",xpaths: ["//input[@id='txtUserID']"], xpath: "//input[@id='txtUserID']",dom_name:"", dom_id:"", class:"",css:"", link:"", horizontal_index:"", partial_link:"", tag:"", desc:"",webpageId:"", warnings: {}, selectedWebPageId: {}}); 
    WebobjectMock.models.push({_id:"ewhfiuewnfewyy", type: "WEB", deleted: 0, collectionName: "", request: {}, dbName: "db1", webPageId: "", name: "Password",/*  wId :++this.idCounter, */ webobjectType:"", xpaths: ["//input[@id='txtPassword']"], xpath : "//input[@id='txtPassword']",dom_name:"", dom_id:"", class:"",css:"", link:"", horizontal_index:"", partial_link:"", tag:"", desc:"",webpageId:"", warnings: {}, selectedWebPageId: {}}); 
    WebobjectMock.models.push({_id:"", type: "WEB", deleted: 0, collectionName: "", request: {}, dbName: "db1", webPageId: "", name: "LogInButton",/*  wId :++this.idCounter, */ webobjectType:"", xpaths: ["//button[@id='sub']"], xpath : "//button[@id='sub']", dom_name:"", dom_id:"", class:"",css:"", link:"", horizontal_index:"", partial_link:"", tag:"", desc:"",webpageId:"", warnings: {}, selectedWebPageId: {}});
    WebobjectMock.models.push({_id:"eofoefoefjof", type: "WEB", deleted: 0, collectionName: "", request: {}, dbName: "db1", webPageId: "", name: "Brandlogo",/*  wId :++this.idCounter, */ webobjectType:"", xpaths: ["//i/img[contains(@name,'pyPortal')]"], xpath : "//i/img[contains(@name,'pyPortal')]",dom_name:"", dom_id:"", class:"",css:"", link:"", horizontal_index:"", partial_link:"", tag:"", desc:"",webpageId:"", warnings: {}, selectedWebPageId: {}});
  }

  public static update(webobject):WebObjectModel{
    let m = WebobjectMock.models;
    for(let i = 0; i< m.length; i++){
      if(webobject.id == m[i]._id) {
        m[i]=webobject;
        return m[i];}
    }
    return null;
  }

  public static findByObjectId(id: string):WebObjectModel{
    let m = WebobjectMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i]._id) return m[i];
    }
    return null;
  }

/*   public static findById(id:number):WebObjectModel{
    let m = WebobjectMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i]._id) return m[i];
    }
    return null;
  } */

  public static getItems():WebObjectModel[]{
    return WebobjectMock.models;
  }




}